const TableHeader = ({ items, backgroundColor, headerClass, fs }) => {
  return (
    <thead className={`${fs}`} style={{ backgroundColor: backgroundColor }}>
      <tr>
        {items.map((item, index) => {
          return (
            <th key={index} className={headerClass}>
              {item}
            </th>
          );
        })}
      </tr>
    </thead>
  );
};

export default TableHeader;
